import { LocationDto } from "@braoshzmvavz/picnube-common";
import { ActionIcon, Button, Group, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";

export default function MapOverlayButton(props: {
  style: any;
  icon: React.ReactNode;
  onClick: () => void;
}) {
  return (
    <div
      className="absolute top-2 right-2 w-10 h-10 rounded-full"
      style={props.style}
    >
      <ActionIcon.Group orientation="vertical">
        <ActionIcon
          variant="default"
          size="lg"
          aria-label="Add"
          onClick={props.onClick}
        >
          {props.icon}
        </ActionIcon>
      </ActionIcon.Group>
    </div>
  );
}
